import styled from "styled-components";

export const NotFoundStyled = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgb(247, 247, 247);
  height: 100vh;
  max-height: 100%;
  img {
    width: 35%;
  }
  div {
    display: flex;
    flex-direction: column;
    button {
      background-color: transparent;
      border: none;
      cursor: pointer;
      img {
        width: 25%;
      }
    }
  }
`;
